<p-toast></p-toast>
<div class="splash-container">
  <div class="splash-wrapper">
    <p-card class="splash-card">
      <ng-template pTemplate="header">
        <div class="splash-header">
          <img src="GoVideoSplash.png" alt="GoVideo Logo" class="logo" />
        </div>
      </ng-template>
    <ng-template pTemplate="content">
      <div class="splash-content">
        <p-button 
          label="Enter GoVideo" 
          styleClass="enter-button"
          [loading]="isLoading"
          (onClick)="enterGoVideo()">
        </p-button>
      </div>
    </ng-template>
    <ng-template pTemplate="footer">
      <div class="splash-footer">
        <div class="version">v3.0</div>
      </div>
    </ng-template>
    </p-card>
  </div>
</div>
